export default "/assets/website/images/favourite-medium-standard.svg?ac178ab7da6b34d3a33cd3ec97d6ae8f";